import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

function OperationsQueue () {
  const { setPageName } = useOutletContext();

  useEffect(() => {
    setPageName('Operaciones');
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <h1>this is the OperationsQueue page</h1>
        </div>
      </div>
    </div>

  );
}

export default OperationsQueue;